import { render, staticRenderFns } from "./addRecipientSummary.vue?vue&type=template&id=cd8aabba&scoped=true"
import script from "./addRecipientSummary.vue?vue&type=script&lang=js"
export * from "./addRecipientSummary.vue?vue&type=script&lang=js"
import style0 from "./addRecipientSummary.vue?vue&type=style&index=0&id=cd8aabba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8aabba",
  null
  
)

export default component.exports